import { render, staticRenderFns } from "./GClassManagementClassTrend.vue?vue&type=template&id=f0db05aa&scoped=true&"
import script from "./GClassManagementClassTrend.vue?vue&type=script&lang=ts&"
export * from "./GClassManagementClassTrend.vue?vue&type=script&lang=ts&"
import style0 from "./GClassManagementClassTrend.vue?vue&type=style&index=0&id=f0db05aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0db05aa",
  null
  
)

export default component.exports